import { render, staticRenderFns } from "./v-upload-drag.vue?vue&type=template&id=005e5745&"
import script from "./v-upload-drag.vue?vue&type=script&lang=js&"
export * from "./v-upload-drag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports